module.exports = __webpack_public_path__ + "img/symbol_0.8c3cf708.png";